import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";
import { ValueWithLabel } from "@/widgets/value-with-label";
import type { FreightMatching } from "@x-mile/api-contract";
import type { DraftOfferCargo } from "../../model";

export const CompanyInfo = ({
  previewValues,
  companies,
}: {
  previewValues: DraftOfferCargo;
  companies: FreightMatching.schemas.Company[] | null;
}) => {
  const selectedCompany = companies?.find(
    (company) => company.id === previewValues.companyId,
  );

  return (
    <BaseHeaderWrapper title="荷主情報" maxWidth="628px">
      <BaseKeyValue keyLabel="荷主">
        <ValueWithLabel
          label="企業名"
          value={selectedCompany?.name ?? "未選択"}
          emphasis
        />
        <ValueWithLabel label="郵便番号" value={selectedCompany?.zipCode} />
        <ValueWithLabel label="住所" value={selectedCompany?.address} />
        <ValueWithLabel label="電話番号" value={selectedCompany?.phoneNumber} />
        <ValueWithLabel label="FAX番号" value={selectedCompany?.faxNumber} />
        <ValueWithLabel label="メールアドレス" value={selectedCompany?.email} />
      </BaseKeyValue>
    </BaseHeaderWrapper>
  );
};
